module.exports = __webpack_public_path__ + "static/media/newPassword-logo.b688a1aa.png";